import { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import { deleteBadgeAssignation, getInstitutionBadges } from '../../../utils/api/badge'
import { selectUser } from '../../../reducers/UserReducer'
import BadgesTable from './BadgesView/BadgesTable'
import { retrieveMetadata } from '../../../utils/http'
import { TableParameters } from '../../../utils/entities/tableParameters'
import { DEFAULT_FILTERS } from './BadgesView/BadgeFilters'
import { getTimezoneLessMoment } from '../../../utils/momentjs'
import DefaultContainer from '../../../HOC/DefaultContainer'
import BadgeAssignationProvider from '../../../Providers/Badge/BadgeAssignationProvider/BadgeAssignationProvider'
import { getters } from '../../../utils/entities/badge'
import { isObject } from '../../../utils'
import { OrderBy } from '../../../utils/constants'

const BadgesView = () => {
  const user = useSelector(selectUser)

  const [badges, setBadges] = useState({ data: [], metadata: null })
  const [parameters, setParameters] = useState(new TableParameters({ filters: DEFAULT_FILTERS, page: 1, pageSize: 50, order: { by: OrderBy.START_DATE, direction: 'asc' } }))
  const [loading, setLoading] = useState(false)

  const fetchBadgesAssignations = useCallback(parameters => {
    if (user.institutions) {
      setLoading(true)

      delete parameters.filters.columns

      getInstitutionBadges(user, user.institutions[0], parameters).then(({ data, meta }) => {
        setBadges({
          data: data.map(b => ({
            ...b,
            startDate: getTimezoneLessMoment(b.startDate.date),
            endDate: isObject(b.endDate) ? getTimezoneLessMoment(b.endDate.date) : null
          })),
          metadata: retrieveMetadata(meta)
        })
      }).finally(() => setLoading(false))
    }
  }, [user.id])

  useEffect(() => {
    fetchBadgesAssignations(parameters.toQueryParameters())
  }, [fetchBadgesAssignations, parameters])

  const handleDelete = useCallback(badgeAssignation => {
    deleteBadgeAssignation(user, { id: getters.badgeAssignationId(badgeAssignation) }).finally(() => fetchBadgesAssignations(parameters.toQueryParameters()))
  }, [user.id, fetchBadgesAssignations])

  return (
    <DefaultContainer offset={130}>
      <BadgeAssignationProvider>
        <BadgesTable
          data={badges.data}
          metadata={badges.metadata}
          parameters={parameters}
          loading={loading}
          onChange={() => fetchBadgesAssignations(parameters.toQueryParameters())}
          onDelete={handleDelete}
          onFiltersChange={filters => setParameters(new TableParameters({ ...parameters, filters, page: 1 }))}
          onParametersChange={setParameters}
        />
      </BadgeAssignationProvider>
    </DefaultContainer>

  )
}

export default BadgesView
